"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var server_1 = require("react-dom/server");
var SeriesIndicator = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 6px;\n  width: 24px;\n  background-color: ", ";\n  margin-bottom: 8px;\n"], ["\n  height: 6px;\n  width: 24px;\n  background-color: ", ";\n  margin-bottom: 8px;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
SeriesIndicator.displayName = 'SeriesIndicator';
exports.SmallSeriesIndicator = styled_components_1.default(SeriesIndicator)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  top: 6px;\n  height: 4px;\n  width: 16px;\n  display: inline-block;\n  margin-right: 8px;\n"], ["\n  position: relative;\n  top: 6px;\n  height: 4px;\n  width: 16px;\n  display: inline-block;\n  margin-right: 8px;\n"])));
exports.SmallSeriesIndicator.displayName = 'SmallSeriesIndicator';
var LabelContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n  margin-right: 8px;\n"], ["\n  display: inline-flex;\n  margin-right: 8px;\n"])));
LabelContainer.displayName = 'LabelContainer';
var LegendValue = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  text-transform: uppercase;\n  font-weight: normal;\n"], ["\n  color: ", ";\n  text-transform: uppercase;\n  font-weight: normal;\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.charts.label;
});
LegendValue.displayName = 'LegendValue';
var ToolTipValue = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.charts.tooltipValue;
});
ToolTipValue.displayName = 'ToolTipValue';
var SeriesContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  opacity: ", ";\n  margin-left: 30px;\n  margin-top: 20px;\n"], ["\n  opacity: ", ";\n  margin-left: 30px;\n  margin-top: 20px;\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? '1' : '0.4');
});
SeriesContainer.displayName = 'SeriesContainer';
var PointContainer = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  min-width: 180px;\n  font-size: 12px;\n  margin-bottom: 4px;\n  justify-content: space-between;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  min-width: 180px;\n  font-size: 12px;\n  margin-bottom: 4px;\n  justify-content: space-between;\n\n  &:last-of-type {\n    margin-bottom: 0;\n  }\n"])));
PointContainer.displayName = 'PointContainer';
function pointFormatter(_a) {
    var theme = _a.theme, locale = _a.locale, valueFormatter = _a.valueFormatter;
    return function () {
        var _a = this, y = _a.y, name = _a.series.userOptions.name, color = _a.color;
        var formatWithDigits = locale.formatWithDigits;
        return server_1.renderToStaticMarkup(react_1.default.createElement(PointContainer, null,
            react_1.default.createElement(LabelContainer, null,
                react_1.default.createElement(exports.SmallSeriesIndicator, { color: color }),
                react_1.default.createElement("span", null, name)),
            react_1.default.createElement(ToolTipValue, { "data-test-id": "tooltip-value", theme: theme }, y && ((valueFormatter && valueFormatter(y)) || formatWithDigits(y, 2)))));
    };
}
exports.pointFormatter = pointFormatter;
function legendItemFormatter(theme) {
    return function () {
        var _a = this, name = _a.name, visible = _a.visible;
        return server_1.renderToStaticMarkup(react_1.default.createElement(SeriesContainer, { visible: visible },
            'color' in this && react_1.default.createElement(SeriesIndicator, { color: this.color }),
            react_1.default.createElement(LegendValue, { theme: theme }, name)));
    };
}
exports.default = legendItemFormatter;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
